export default __webpack_public_path__ + "static/media/figo-logo-white.274b0451.svg";